<template>
<div class="dialog">
  <el-dialog :title="title" :visible.sync="centerDialogVisible" :close-on-click-modal="closeOnClickModal" :modal-append-to-body="false" :width="dlgWidth" center :before-close="handleClose">
    <template>
      <div class="content">
        <slot></slot>
      </div>
    </template>
    <div slot="footer" class="dialog-footer">
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    },
    dlgWidth: {
      type: String,
      default: '30%'
    },
    closeOnClickModal:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      centerDialogVisible: false
    };
  },
  methods: {
    open() {
      this.centerDialogVisible = true;
    },
    close() {
      this.centerDialogVisible = false;
    },
    handleClose() {
      this.centerDialogVisible = false;
      this.$emit("closeDialog");
    }
  },
  created() {},
  mounted() {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.dialog {
  height: 100%;
  width: 100%;

  .dialog-footer {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog.vue